module.exports = __webpack_public_path__ + "static/img/hy1.09c50d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/hy1.png
// module id = Polp
// module chunks = 2